export default __webpack_public_path__ + "static/media/1_4_logo.69a291eb.png";